/**
 * Unified CloudBase Auth Service
 * 统一认证服务入口
 */

import { realCloudBaseAuth } from './realAuth';
import { isLocalSession, localAuth } from '../localAuth';
import { isLocalAccount, isLocalAccessToken } from '../localAuthTokens';
import type {
  AuthResult,
  CloudBaseUser,
  PhoneLoginCredentials,
  EmailCodeLoginCredentials,
  PasswordLoginCredentials,
  PhoneRegisterData,
  EmailRegisterData,
  SendCodeResult,
} from './types';

/**
 * CloudBase Auth Service Interface
 */
export interface ICloudBaseAuthService {
  loginWithPhoneCode(credentials: PhoneLoginCredentials): Promise<AuthResult>;
  loginWithEmailCode(credentials: EmailCodeLoginCredentials): Promise<AuthResult>;
  loginWithPassword(credentials: PasswordLoginCredentials): Promise<AuthResult>;
  registerByPhone(data: PhoneRegisterData): Promise<AuthResult>;
  registerByEmail(data: EmailRegisterData): Promise<AuthResult>;
  sendSmsCode(phone: string): Promise<SendCodeResult>;
  sendEmailCode(email: string): Promise<SendCodeResult>;
  getCurrentUser(token: string): Promise<CloudBaseUser | null>;
  logout(): Promise<void>;
}

/**
 * Export unified auth service
 */
export const cloudBaseAuth: ICloudBaseAuthService = {
  ...realCloudBaseAuth,
  loginWithPassword: credentials => isLocalAccount(credentials.account)
    ? localAuth.loginWithPassword(credentials) : realCloudBaseAuth.loginWithPassword(credentials),
  getCurrentUser: token => isLocalAccessToken(token)
    ? localAuth.getCurrentUser() : realCloudBaseAuth.getCurrentUser(token),
  logout: () => isLocalSession() ? localAuth.logout() : realCloudBaseAuth.logout(),
};
